export default __webpack_public_path__ + "static/media/lucky_draw_step.cca0876e.svg";